
import baseComponentFactory from './baseComponentFactory';
import { useLocalProp } from '@sbvr/lbe-composition-helpers';

export default baseComponentFactory({
  name: 'UICheckbox',
  props: {
    value: {
      type: Boolean as () => boolean,
    },
    disabled: Boolean,
  },
  setup (props, { emit }) {
    const internalValue = useLocalProp({ props, emit }, 'value');
    return {
      internalValue,
    };
  },
});
